import { Injectable, inject } from "@angular/core";
import { ClientService, IClient } from "@auvious/client";
import { UserRoleEnum } from "../core-ui.enums";
import { ApiResource } from "@auvious/common";
import { AuviousRtcService } from "./rtc.service";

@Injectable()
export class AuthProviderService {
  private clientService = inject(ClientService);


  async createClient(description: string, roles: string[]): Promise<IClient> {
    return this.clientService.create(description, roles);
  }

  listClients(): Promise<IClient[]> {
    return this.clientService.list();
  }

  revokeClient(clientId: string) {
    return this.clientService.delete(clientId);
  }

  updateClient(clientId: string, description: string, roles?: string[]) {
    return this.clientService.update(clientId, description, roles);
  }
}
